import React, { useEffect, useState } from "react";

// Redux
import { Link } from "react-router-dom";
import { Row, Col, CardBody, Card, Container, Form, Input, Label, FormFeedback, Alert } from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/dofy-logo.png";
import lightlogo from "../../assets/images/dofy-logo.png";

//import thunk
import { loginuser, resetLoginMsgFlag, socialLogin } from "slices/auth/login/thunk";

import withRouter from "components/Common/withRouter";
import { createSelector } from 'reselect';
import { useNavigate } from 'react-router-dom';
import { CustomDropdown } from "components/shared/CustomDropdown";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import UAParser from "ua-parser-js";

const CountrySection = (props: any) => {
    const [countryId, setCountryId] = useState(0);
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [appVersion, SetAppVersion] = useState<any>('');

    //meta title
    document.title = "Country Section | DOFY-Admin";

    const SectionData = [
        {
            id: 1,
            name: 'India',
        },
        {
            id: 2,
            name: 'UAE',
        }
    ]

    const routerHandler = (val: any) => {
        setCountryId(val);
        if (val == 1) {
            localStorage.setItem('CountryCode', 'in');
            localStorage.setItem('LanguageCode', 'en');
            window.location.replace('/login');
        }
        else {
            localStorage.setItem('CountryCode', 'ae');
            localStorage.setItem('LanguageCode', 'en');
            window.location.replace('/login');
        }
    }

    return (
        <React.Fragment>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden p-0">
                                <div className="bg-dofy">
                                    <Row>
                                        <Col className="col-7">
                                            <div className="text-white p-4">
                                                <h5 className="text-white fw-semibold">Welcome Back !</h5>
                                                <p className="text-white">Sign in to continue to DOFY.</p>
                                            </div>
                                        </Col>
                                        <Col className="col-5 align-self-end">
                                            <img src={profile} alt="" className="img-fluid" />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div className="auth-logo">
                                        <Link to="/" className="auth-logo-light">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src={lightlogo}
                                                        alt=""
                                                        className="rounded-circle"
                                                        height="42"
                                                    />
                                                </span>
                                            </div>
                                        </Link>
                                        <Link to="/" className="auth-logo-dark">
                                            <div className="avatar-md profile-user-wid">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src={logo}
                                                        alt=""
                                                        className="rounded-circle"
                                                        height="42"
                                                    />
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="p-2">
                                        <div className="">
                                            <CustomDropdown isMandatory={true} label={'Country'} value={countryId} data={SectionData} error={undefined} displayField={"name"} valueField="id" onChange={(e) => routerHandler(e.target.value)} id={undefined} />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>

                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(CountrySection);
